(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sahara-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sahara-device-finder')) {
    customElements.define('sahara-device-finder', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.form = this.querySelector('form');
        const source = this.querySelector('[data-device-directory]');
        if (!source || !this.form) return;
        try {
          this.directory = JSON.parse(source.textContent).map(brand => ({
            label: brand.label,
            families: brand.families.map(family => ({
              label: family.label,
              models: family.models.filter(model => this.destination(model.url))
            })).filter(family => family.models.length)
          })).filter(brand => brand.families.length);
        } catch {
          return;
        }
        if (!this.directory.length) return;
        this.brand = this.querySelector('[data-brand]');
        this.family = this.querySelector('[data-family]');
        this.model = this.querySelector('[data-model]');
        this.submit = this.form.querySelector('[type="submit"]');
        this.status = this.querySelector('[data-status]');
        this.setOptions(this.brand, this.brand.options[0].text, this.directory);
        this.resetFamily();
        const options = { signal: this.controller.signal };
        this.brand.addEventListener('change', () => {
          this.resetFamily();
          const brand = this.directory[this.brand.value];
          if (brand) {
            this.setOptions(this.family, this.dataset.familyPrompt, brand.families);
            this.family.disabled = false;
            this.status.textContent = this.dataset.statusFamily;
          }
        }, options);
        this.family.addEventListener('change', () => {
          this.resetModel();
          const family = this.directory[this.brand.value]?.families[this.family.value];
          if (family) {
            this.setOptions(this.model, this.dataset.modelPrompt, family.models);
            this.model.disabled = false;
            this.status.textContent = this.dataset.statusModel;
          }
        }, options);
        this.model.addEventListener('change', () => {
          this.submit.disabled = !this.selectedModel();
          this.status.textContent = this.submit.disabled ? this.dataset.statusModel : this.dataset.statusReady;
        }, options);
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          const target = this.destination(this.selectedModel()?.url);
          if (target) window.location.assign(target);
        }, options);
        this.form.addEventListener('reset', () => queueMicrotask(() => this.resetFamily()), options);
        this.brand.disabled = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      destination(value) {
        if (typeof value !== 'string' || !value || value.startsWith('#')) return null;
        try {
          const url = new URL(value, window.location.origin);
          if (!['http:', 'https:'].includes(url.protocol) || ![window.location.hostname, this.dataset.storeHost, this.dataset.shopHost].includes(url.hostname)) return null;
          const root = this.dataset.root || '/';
          if (root !== '/' && !url.pathname.startsWith(root)) url.pathname = root.replace(/\/$/, '') + url.pathname;
          return new URL(url.pathname + url.search + url.hash, window.location.origin).href;
        } catch {
          return null;
        }
      }
      selectedModel() {
        return this.directory[this.brand.value]?.families[this.family.value]?.models[this.model.value];
      }
      setOptions(select, prompt, entries) {
        const fragment = document.createDocumentFragment();
        fragment.append(new Option(prompt, ''));
        entries.forEach((entry, index) => fragment.append(new Option(entry.label, String(index))));
        select.replaceChildren(fragment);
        select.value = '';
      }
      resetFamily() {
        this.setOptions(this.family, this.dataset.familyPrompt, []);
        this.family.disabled = true;
        this.resetModel();
      }
      resetModel() {
        this.setOptions(this.model, this.dataset.modelPrompt, []);
        this.model.disabled = true;
        this.submit.disabled = true;
        this.status.textContent = '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
